"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductLabel = exports.PRODUCT_LABEL_STYLE_TYPE = exports.PRODUCT_LABEL_SIZE = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("b2b-components/core/components/Icon");
var _Tooltip = require("b2b-components/core/components/Tooltip");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
require("./ProductLabel.scss");
let PRODUCT_LABEL_SIZE = exports.PRODUCT_LABEL_SIZE = /*#__PURE__*/function (PRODUCT_LABEL_SIZE) {
  PRODUCT_LABEL_SIZE["default"] = "default";
  PRODUCT_LABEL_SIZE["small"] = "small";
  PRODUCT_LABEL_SIZE["semilarge"] = "semilarge";
  return PRODUCT_LABEL_SIZE;
}({});
let PRODUCT_LABEL_STYLE_TYPE = exports.PRODUCT_LABEL_STYLE_TYPE = /*#__PURE__*/function (PRODUCT_LABEL_STYLE_TYPE) {
  PRODUCT_LABEL_STYLE_TYPE["new"] = "new";
  PRODUCT_LABEL_STYLE_TYPE["consciousAlternative"] = "consciousAlternative";
  PRODUCT_LABEL_STYLE_TYPE["sellout"] = "sellout";
  PRODUCT_LABEL_STYLE_TYPE["promotion"] = "promotion";
  PRODUCT_LABEL_STYLE_TYPE["occasion"] = "occasion";
  PRODUCT_LABEL_STYLE_TYPE["coreAssortment"] = "coreAssortment";
  PRODUCT_LABEL_STYLE_TYPE["ownAssortment"] = "ownAssortment";
  return PRODUCT_LABEL_STYLE_TYPE;
}({});
const ProductLabel = _ref => {
  let {
    className,
    isInline = false,
    size = PRODUCT_LABEL_SIZE.default,
    styleType,
    label
  } = _ref;
  const sizeClassName = size === PRODUCT_LABEL_SIZE.small ? 'cds-ProductLabel--Small' : '';
  const iconSize = size === PRODUCT_LABEL_SIZE.default ? _Icon.ICON_SIZE.medium : _Icon.ICON_SIZE[size];
  const specificClassName = `cds-ProductLabel--${(0, _upperCase.upperCaseFirst)(styleType)}`;
  const composedTooltipClassName = isInline ? (0, _classnames.default)('cds-ProductLabel-Tooltip--InlineIcon', className) : className;
  if (styleType === PRODUCT_LABEL_STYLE_TYPE.coreAssortment) {
    return /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
      content: label,
      triggerClassName: "cds-ProductLabel-TooltipTrigger",
      className: composedTooltipClassName
    }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      className: (0, _classnames.default)(specificClassName),
      name: _Icon.ICON_NAME.coreAssortment,
      size: iconSize
    }));
  }
  if (styleType === PRODUCT_LABEL_STYLE_TYPE.ownAssortment) {
    return /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
      content: label,
      triggerClassName: "cds-ProductLabel-TooltipTrigger",
      className: composedTooltipClassName
    }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      className: (0, _classnames.default)(specificClassName),
      name: _Icon.ICON_NAME.printAndPromo,
      size: iconSize
    }));
  }
  const rootClassName = (0, _classnames.default)('cds-ProductLabel', specificClassName, sizeClassName, className);
  const innerHTML = isInline ? label : label.trim().replace(/\s+/g, '<br />');
  return /*#__PURE__*/_react.default.createElement("span", {
    className: rootClassName,
    dangerouslySetInnerHTML: {
      __html: innerHTML
    }
  });
};
exports.ProductLabel = ProductLabel;
//# sourceMappingURL=ProductLabel.js.map